import Vue from 'vue';
export default Vue.extend({
    props: {
        apiErrors: {
            type: Array,
            default: () => [],
        },
        vuelidateField: {
            type: Object,
        },
        label: {
            type: String,
            default: '',
        },
    },
    methods: {
        validateState() {
            if (this.apiErrors.length) {
                return false;
            }
            const { $dirty, $error } = this.vuelidateField;
            return $dirty ? !$error : null;
        },
    },
});
